import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ChangePasswordComponent } from './change-password.component';
import { Injectable, inject } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ChangePasswordService {
  private dialog = inject(MatDialog);


  openChangePasswordDialog(): MatDialogRef<ChangePasswordComponent> {
    return this.dialog.open(ChangePasswordComponent,
      {
        width: '30%',
        maxWidth: '50%',
        disableClose: true,
        autoFocus: false
      });
  }

  openExpiredPasswordDialog(username: string): MatDialogRef<ChangePasswordComponent> {
    return this.dialog.open(ChangePasswordComponent,
      {
        width: '30%',
        maxWidth: '50%',
        disableClose: true,
        autoFocus: false,
        data: {username}
      });
  }
}
